var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-th-button",class:[
    _vm.type ? 'el-th-button--' + _vm.type : '',
    _vm.buttonSize ? 'el-th-button--' + _vm.buttonSize : '',
    {
      'is-th-disabled': _vm.buttonDisabled,
    }
  ],attrs:{"disabled":_vm.buttonDisabled,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b02b260","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/button/SecondaryButton.vue
// module id = 30
// module chunks = 0